<div class="help-page">
  <header class="help-topbar">
    <a class="help-back" href="#" (click)="back($event)">
      <span aria-hidden="true">←</span>Volver al formulario
    </a>
    <span class="help-crumb">Ayuda · Fecha de validez del DNI</span>
  </header>

  <main class="help-wrap help-cols">
    <section class="help-col">
      <h2>¿Cómo saber mi fecha de vencimiento?</h2>
      <span class="help-rule"></span>
      <p class="help-lead">La fecha de vencimiento es la que indica hasta cuándo está en vigor tu DNI.</p>
      <div class="help-card">
        <span class="help-pill">En tu DNI actual</span>
        <div class="help-imgs">
          <figure class="help-fig">
            <img [src]="'img/illustrations/expiration-date-2.webp' | assetUrl" width="1020" height="621" loading="lazy" alt="DNI 3.0 con un recuadro rojo sobre el campo VALIDEZ">
            <ul class="help-legend">
              <li><span class="help-swatch" aria-hidden="true"></span>Campo «VALIDEZ» · DNI 3.0</li>
            </ul>
          </figure>
          <figure class="help-fig">
            <img [src]="'img/illustrations/expiration-date-1.webp' | assetUrl" width="1020" height="615" loading="lazy" alt="DNI anterior a 2015 con un recuadro rojo sobre el campo VÁLIDO HASTA">
            <ul class="help-legend">
              <li><span class="help-swatch" aria-hidden="true"></span>Campo «VÁLIDO HASTA» · DNI anterior a 2015</li>
            </ul>
          </figure>
        </div>
        <div class="help-foot">
          <p>Busca el campo <strong>“VALIDEZ”</strong> o <strong>“VÁLIDO HASTA”</strong>. Esa es tu fecha de vencimiento.</p>
          <div class="help-ex">
            <span class="help-chip">02 06 2031</span>
            <span class="help-arrow" aria-hidden="true">→</span>
            <span class="help-chip">02/06/2031</span>
          </div>
        </div>
      </div>
    </section>

    <section class="help-col">
      <h2>Y si mi DNI no tiene fecha de validez, ¿qué dato introduzco?</h2>
      <span class="help-rule"></span>
      <p class="help-lead">En este caso, introduce la fecha de expedición que aparece en tu DNI.</p>
      <div class="help-card">
        <span class="help-pill">En tu DNI sin fecha de validez</span>
        <div class="help-imgs">
          <figure class="help-fig">
            <img [src]="'img/illustrations/expiration-date-3.webp' | assetUrl" width="1020" height="651" loading="lazy" alt="DNI con un recuadro rojo sobre los seis dígitos de la fecha de expedición, junto al escudo">
            <ul class="help-legend">
              <li><span class="help-swatch" aria-hidden="true"></span>Fecha de expedición (DDMMAA)</li>
            </ul>
          </figure>
        </div>
        <div class="help-foot">
          <p>Busca los <strong>seis dígitos junto al escudo</strong> (fecha de expedición, DDMMAA). Esa es la fecha que debes introducir.</p>
          <div class="help-ex">
            <span class="help-chip">010115</span>
            <span class="help-arrow" aria-hidden="true">→</span>
            <span class="help-chip">01/01/2015</span>
          </div>
        </div>
      </div>
    </section>
  </main>

  <div class="help-note-wrap">
    <div class="help-note">
      <i aria-hidden="true">i</i>
      <div>
        <p class="help-note-title">Importante</p>
        <p>Asegúrate de introducir la fecha en formato DD/MM/AAAA.</p>
      </div>
    </div>
  </div>

  <a class="help-cta" href="#" (click)="back($event)">Volver al formulario</a>
</div>
